<template>
    <div class="row">
        <div class="col-md-12">
        </div>
    </div>
</template>

<script>
export default {
  name: 'Dashboard',
  created: function () {
    this.$store.commit('loading/change', false)
    this.$emit('activeMenu', '/admin')
    this.$emit('updateTitle', 'Dashboard')
    this.$emit('updateDisable', true)
  },
  methods: {
    goTo (route) {
      this.$router.push(route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Dashboard.vue